import React, { Component, Fragment } from "react";
import $ from "jquery";
import ReactAudioPlayer from 'react-audio-player';
import ReactHtmlParser from 'react-html-parser';

class Question extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    vybranaOdpoved: 0
  };

  stylePath = {
    fontSize: 15
  };

  styleQuestion = {
    fontSize: 18
  };

  handleChange = event => {
    // console.log(
    //   "Odpoved se zmenila z",
    //   this.state.vybranaOdpoved,
    //   "na",
    //   event.target.value
    // );
    //this.state.vybranaOdpoved = event.target.value;
    this.setState({ vybranaOdpoved: event.target.value });
    //console.log("ulozeno", this.state.vybranaOdpoved);
  };

  // handleSubmit = () => {
  //   console.log("Odeslani formulare");
  //   this.props.onSubmit();
  // };

  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log("Question is updated");
    // console.log("Prev props", prevProps);
    // console.log("Prev state", prevState);
    // console.log("Snapshot", snapshot);

    if (prevProps.zadani.otazka !== this.props.zadani.otazka) {
      //console.log("Nova otazka !!");
      $("#odpoved").text = null;
    }

    //ajax data calss
  }

  render() {
    //console.log("Props", this.props);
    return (
      <div>
        {this.RenderModal()}

        {this.renderOtazka()}

        {this.props.finishedQuestion === true ? (
          <div className="row mt-4">
            <div className="col">
              <button className="btn btn-secondary" onClick={this.props.onPrev}>
                Předchozí
              </button>
            </div>
            <div className="col">
              <button
                className="btn btn-primary float-right"
                onClick={this.props.onNext}
              >
                Další
              </button>
            </div>
          </div>
        ) : (
          <form className="col">
            {this.renderOdpovedi()}

            {this.renderHlaseni()}

            <div className="row">
              <div className="col">
                <button
                  className="btn btn-secondary float-left"
                  onClick={this.props.onPrev}
                >
                  Předchozí
                </button>
              </div>
              <div className="col">
                <button
                  className="btn btn-primary float-right"
                  onClick={this.props.onSubmit}
                >
                  Odeslat
                </button>
              </div>
            </div>


            

            {this.props.finishedQuestion === false ? (
              <div className="mt-5">
                {this.props.zadani.napovedy.length > 0 ? (
                <Fragment>
                {this.renderHelpButton(0)}
                {this.renderHelpButton(1)}
                {this.renderHelpButton(2)}
                {this.renderHelpButton(3)}
                </Fragment>
                ) : null}
                <button
                  type="button"
                  className="btn btn-secondary float-right alert-warning"
                  data-toggle="modal"
                  data-target="#exampleModalCenter"
                >
                  Přeskočit
                </button>
              </div>
            ) : null}

            {this.props.zadani.napovedy.length > 0 ? (
              <Fragment>
            <div className="collapse multi-collapse" id="napoveda1">
              <div className="card card-body">
                {this.props.zadani.napovedy[0].text}

                {this.props.zadani.napovedy[0].img !== undefined ? (
                  <img
                    className="img-fluid"
                    alt="napoveda1"
                    src={this.props.zadani.napovedy[0].img}
                  />
                ) : null}
              </div>
            </div>

            <div className="collapse multi-collapse" id="napoveda2">
              <div className="card card-body">
                {this.props.zadani.napovedy[1].text}
                {this.props.zadani.napovedy[1].img !== undefined ? (
                  <img
                    className="img-fluid"
                    alt="napoveda2"
                    src={this.props.zadani.napovedy[1].img}
                  />
                ) : null}
              </div>
            </div>

            <div className="collapse multi-collapse" id="napoveda3">
              <div className="card card-body">
                {this.props.zadani.napovedy[2].text}
                {this.props.zadani.napovedy[2].img !== undefined ? (
                  <img
                    className="img-fluid"
                    alt="napoveda3"
                    src={this.props.zadani.napovedy[2].img}
                  />
                ) : null}
              </div>
            </div>

            <div className="collapse multi-collapse" id="napoveda4">
              <div className="card card-body">
                {this.props.zadani.napovedy[3].text}
                {this.props.zadani.napovedy[3].img !== undefined ? (
                  <img
                    className="img-fluid"
                    alt="napoveda3"
                    src={this.props.zadani.napovedy[3].img}
                  />
                ) : null}
              </div>
            </div>
            </Fragment>
            ) : null}
          </form>
        )}
      </div>
    );
  }

renderOtazka = () => {
  //console.log("Otazka:", this.props.zadani.otazka);
  let stavba = [];

  for (let i=0; i< this.props.zadani.otazka.length; i++)
  {
      let prvek = this.props.zadani.otazka[i];
      //console.log("prvek", prvek);
      if (prvek.sound!=="" && prvek.sound!==undefined)
      {
          stavba.push(
            <div className="mt-1"> 
            <React.Fragment key={i}>
              <ReactAudioPlayer src={prvek.sound} autoPlay controls /> 
            </React.Fragment></div>);
      }

      if (prvek.img!=="" && prvek.img!==undefined)
      {
          stavba.push(
            <React.Fragment key={i}>
            <div className="d-flex align-items-center mt-1">
            <img
              className="img-fluid mx-auto"
              alt="otazka"
              src={prvek.img} />
              </div>
            </React.Fragment>);
      }

      
      if (prvek.text!=="" && prvek.text!==undefined)
      {
          stavba.push(
            <React.Fragment key={i}>
              {this.textToHtml(prvek.text)}
            </React.Fragment>);
      }
  }

  //console.log("Stavba: ",stavba);
  return  (<div className="col mt-2 border-light" style={this.styleQuestion}> {  stavba } </div>);
}

  textToHtml(html) {
    return  (<div> { ReactHtmlParser (html) } </div>);
  }

  renderOdpovedi = () => {
    if (this.props.zadani.odpovedi.length > 1) {
      return this.props.zadani.odpovedi.map(odpoved => (
        <div className={this.getAnswerClasses(odpoved)} key={odpoved.id}>
          <input
            className="form-check-input"
            type="radio"
            name="exampleRadios"
            id={odpoved.id}
            value={odpoved.id}
            checked={this.props.selected === odpoved.id}
            onChange={this.props.onChange}
          />
          <label className="form-check-label " htmlFor={odpoved.id}>
            {odpoved.text}
          </label>
        </div>
      ));
    } else {
      return (
        <div className="row mt-3 mb-3">
          <div className="col">
            <label htmlFor="odpoved">Odpověď:</label>

            <input className="form-control"
              type="textbox"
              id="odpoved"
              onChange={this.props.onChange}
              onKeyPress={this.props.onKeyPress}
              value={this.props.textovaOdpoved}
            />
          </div>
        </div>
      );
    }
  };

  renderHelpButton(num) {
    let odkaz = "#napoveda" + (num + 1);
    if (num <= this.props.pouzitychNapoved) {
      let trida = "btn m-1 btn-";
      if (num === this.props.pouzitychNapoved) trida += "warning";
      else trida += "info";

      //$("napoveda1").collapse("show");

      return (
        <a
          className={trida}
          data-toggle="collapse"
          href={odkaz}
          role="button"
          aria-expanded="false"
          aria-controls="napoveda1"
          id={num + 1}
          onClick={this.props.onReveal}
        >
          {num + 1}
        </a>
      );
    }
  }

  RenderModal() {
    return (
      <div
        className="modal fade"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalCenterTitle">
                Přeskočení otázky
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              Opravdu chcete přeskočit otázku? Přičte se Vám 30 minut k času.
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-secondary"
              >
                Zrušit
              </button>
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-primary"
                onClick={this.props.onSkip}
              >
                Přeskočit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderHlaseni() {
    if (this.props.hlaseni.length !== 0)
      return <div className="alert alert-danger">{this.props.hlaseni}</div>;
  }

  getAnswerClasses = odpoved => {
    //console.log("odpoved", odpoved, this.state.vybranaOdpoved);

    let classes = "p-1 m-2 form-check ";
    if (this.props.selected === odpoved.id) {
      if (this.props.hlaseni.length !== 0) classes += "alert-danger";
      else classes += "alert-success";
    } else {
      classes += "choice";
    }

    //console.log("getAnswerClasses result: ", classes);
    return classes;
  };
}

export default Question;
